import React from "react";
import { useFeatureFlag } from "../../../../launch-darkly";
import { Header, SlideLayout, Text } from "../../shared-components";
import { IconVariant } from "../../shared-components/Header";
import Slack from "./assets/slack.svg";
import SlackAI from "./assets/slackai.png";

export const SlackSlide = () => {
  const [isOnAIOnboarding] = useFeatureFlag("rollout-ai-onboarding");

  if (isOnAIOnboarding) {
    return (
      <SlideLayout>
        <Header> Download Clockwise for Slack </Header>
        <Text>
          Harness the power of an intelligent calendar assistant, delivered right where you and your
          teammates are.
        </Text>
        <div className="cw-my-6 cw-w-full cw-flex cw-items-center cw-justify-center">
          <img src={SlackAI} className="cw-w-full md:cw-w-[640px] md:cw-h-[400px]" />
        </div>
      </SlideLayout>
    );
  }

  return (
    <SlideLayout>
      <Header iconVariant={IconVariant.Slack}> Download Clockwise for Slack </Header>
      <Text>
        Our Chrome extension allows you to access Clockwise in your daily workflows, without ever
        having to leave your calendar.
      </Text>
      <div className="cw-my-6 cw-w-full cw-flex cw-items-center cw-justify-center">
        <img src={Slack} className="cw-w-full md:cw-w-[600px]" />
      </div>
    </SlideLayout>
  );
};
